// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".control[data-v-3079f6e4]{border:1px #ddd solid;border-radius:5px;display:inline-block;transition:opacity 300ms ease-out}.control div[data-v-3079f6e4]{border-right:1px #ddd solid;padding:0 5px;height:20px;line-height:20px}.control div[data-v-3079f6e4]:last-child{border-right:0}.control.big div[data-v-3079f6e4]{padding:0 10px;height:40px;line-height:40px}.control.inactive[data-v-3079f6e4]{opacity:0.5}\n", ""]);
// Exports
module.exports = exports;
